import React from 'react'
import PropTypes from 'prop-types'

const Label = ({ title, content }) => (
  <div className="jisr-form-group">
    <label className="label-field">{title}</label>
    <div>{content}</div>
  </div>
)

Label.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
}

export default Label
